import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { TModalContent, TModalState } from 'shared/types/features';

const initialState: TModalState = {
  content: null,
};

/* istanbul ignore next */
const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    setModalContent: (state, action: PayloadAction<TModalContent>) => {
      state.content = action.payload;
    },
  },
});

export const {
  reducer: modalReducer,
  actions: { setModalContent },
} = modalSlice;
